import { Injectable } from "@angular/core";
import { BehaviorSubject, forkJoin, Observable, of } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import { ZoneEntity } from "src/app/models/inspection.model";
import { GlobalApiCallsService } from "../global-api-calls.service";
@Injectable({
	providedIn: "root",
})
export class ZoneNamesService {
	constructor(private globalService: GlobalApiCallsService) {}

	private _zoneNameCache = new Map();
	unknownZone = {
		id: "unknown",
		name: "Unknown Zone",
		categoryId: "unknown",
		status: "unknown",
	};

	categoryId$ = new BehaviorSubject(null);

	getZoneNames(zoneIds: string[]): Observable<{ zoneNames: string; zones: ZoneEntity[] }> {
		let _catId = null;
		const obs = zoneIds.map(id => {
			if (this._zoneNameCache.has(id)) {
				const zone = this._zoneNameCache.get(id);
				_catId = zone.categoryId;
				return of(zone);
			}
			return this.globalService.getZoneById(id).pipe(
				tap(zone => {
					this._zoneNameCache.set(id, zone);
					_catId = zone.categoryId;
				}),
				map(zone => {
					return zone;
				}),
				catchError(err => {
					console.log(err);
					this._zoneNameCache.set(id, this.unknownZone);
					return of(this.unknownZone);
				}),
			);
		});

		return forkJoin(obs).pipe(
			map(zones => {
				this.categoryId$.next(_catId);

				return {
					zoneNames: zones
						.map(z => z.name)
						.join(", ")
						.trim(),
					zones,
				};
			}),
		);
	}

	getCategoryById(catId: string) {
		return this.globalService.getCategoryById(catId);
	}
}
